import { useState } from "react";
import Modal from "react-modal";

Modal.setAppElement("#root");

export default function JobApply() {

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* GLOWING BUTTON */}

      <div className="flex justify-start mb-10">

        <button
          onClick={() => setIsOpen(true)}
          className="bg-zinc-900 border border-cyan-500 shadow-[0_0_25px_rgba(34,211,238,0.35)] hover:scale-105 transition duration-300 px-6 py-4 rounded-2xl text-white font-semibold"
        >
          Apply for Customer Service
        </button>

      </div>

      {/* MODAL */}

      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        className="max-w-xl mx-auto mt-20 bg-zinc-950 border border-zinc-800 rounded-3xl p-8 outline-none"
        overlayClassName="fixed inset-0 bg-black/70 z-50 px-4"
      >

        <div className="flex justify-between items-center mb-6">

          <h2 className="text-3xl font-bold text-white">
            Application Form
          </h2>

          <button
            onClick={() => setIsOpen(false)}
            className="text-zinc-400 hover:text-white"
          >
            ✕
          </button>

        </div>

        <form
          action="https://formsubmit.co/developwithmanish@gmail.com"
          method="POST"
          className="flex flex-col gap-5"
        >

          <input
            type="text"
            name="name"
            placeholder="Full Name"
            required
            className="bg-zinc-900 border border-zinc-700 rounded-xl px-4 py-3 text-white outline-none"
          />

          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            required
            className="bg-zinc-900 border border-zinc-700 rounded-xl px-4 py-3 text-white outline-none"
          />

          <input
            type="email"
            name="email"
            placeholder="Email Address"
            required
            className="bg-zinc-900 border border-zinc-700 rounded-xl px-4 py-3 text-white outline-none"
          />

          <textarea
            name="address"
            placeholder="Address"
            rows="3"
            required
            className="bg-zinc-900 border border-zinc-700 rounded-xl px-4 py-3 text-white outline-none"
          />

          {/* LANGUAGES */}

          <div>

            <p className="text-zinc-300 mb-3">
              Languages Fluent In
            </p>

            <div className="flex gap-6 text-zinc-300">

              <label className="flex items-center gap-2">
                <input type="checkbox" name="language" value="Hindi" />
                Hindi
              </label>

              <label className="flex items-center gap-2">
                <input type="checkbox" name="language" value="English" />
                English
              </label>

            </div>

          </div>

          <button
            type="submit"
            className="bg-white text-black rounded-xl py-3 font-semibold hover:scale-105 transition"
          >
            Submit Application
          </button>

        </form>

      </Modal>
    </>
  );
}